import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 600,
    marginTop: theme.spacing(1),
    fontSize: '1.08em',
  },
  listTitle: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
    maxWidth: 633,
    lineHeight: 1.5,
    fontSize: '1.15em',
  },
  list: {
    margin: 0,
    paddingLeft: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    '& li': {
      marginBottom: theme.spacing(0.5),
    },
    '& .checked': {
      listStyleType: 'none',
      marginLeft: theme.spacing(-2),
      display: 'flex',
      gap: '5.5px',
      alignItems: 'center',
    },
    '& svg': {
      width: '18px',
      height: '18px',
    },
    '& li p': {
      color: theme.palette.text.secondary,
      lineHeight: 1.25,
      fontSize: '1.15em',
    },
    '&:last-child': {
      marginBottom: 0,
    },
  },
  passwordField: {
    maxWidth: '358px',
    '& div': {
      maxHeight: '44px',
    },
    '& button': {
      padding: '9px 14px',
    },
    '& input': {
      padding: '11px 16px',
    },
  },
}));

export const useValidationStyles = makeStyles((theme) => ({
  valid: {
    '& .MuiTypography-root.MuiTypography-body1': {
      color: theme.palette.success.main,
    },
    '& svg': {
      color: theme.palette.success.main,
    },
  },
  invalid: {
    '& .MuiTypography-root.MuiTypography-body1': {
      color: theme.palette.error.main,
    },
    '& svg': {
      color: theme.palette.error.main,
    },
  },
}));
